import Browser from 'browser';
import AbstractWatchableBrickConfig from './abstract-watchable-brick-config';

const BASE_TEN = 10;

export default class PublisherBrickConfig extends AbstractWatchableBrickConfig {
  constructor(params) {
    super(params);

    this.buildWithIframe = true;
    this.hideAttribution = params.hideAttribution;
    this.hideModalButton = params.hideModalButton;
    this.modalButtonText = params.modalButtonText;
    this.providerIdOrder = params.providerIdOrder;
    this.providerIdBlacklist = params.providerIdBlacklist;
    this.providerIdWhitelist = params.providerIdWhitelist;
    this.useDarkLogos = params.useDarkLogos;
    this.borderColor = params.borderColor;
    this.borderHoverColor = params.borderHoverColor;
    this.textColor = params.textColor;
    this.size = params.size;
  }

  errors() {
    const errorArray = super.errors();

    if (this.size) {
      const intSize = Browser.getWindow().parseInt(this.size, BASE_TEN);

      if (intSize === 0) {
        errorArray.push('size cannot be 0');
      } else if (Browser.getWindow().isNaN(intSize)) {
        errorArray.push(`unrecognized value for size -- ${this.size}`);
      }
    }

    if (this.providerIdOrder) {
      const array = PublisherBrickConfig.checkIntegerArray(this.providerIdOrder, 'providerIdOrder');
      array.forEach(error => errorArray.push(error));
    }

    if (this.providerIdBlacklist) {
      const array = PublisherBrickConfig.checkIntegerArray(this.providerIdBlacklist, 'providerIdBlacklist');
      array.forEach(error => errorArray.push(error));
    }

    if (this.providerIdWhitelist) {
      const array = PublisherBrickConfig.checkIntegerArray(this.providerIdWhitelist, 'providerIdWhitelist');
      array.forEach(error => errorArray.push(error));
    }

    return errorArray;
  }

  static checkIntegerArray(string, attributeName) {
    const errorArray = [];

    const array = string.split(',').map(id => id.trim());
    array.forEach((id) => {
      const intId = Browser.getWindow().parseInt(id, BASE_TEN);
      if (intId === 0) {
        errorArray.push(`${attributeName} cannot include 0`);
      } else if (Browser.getWindow().isNaN(intId)) {
        errorArray.push(`cannot recognize value in ${attributeName} -- ${id}`);
      }
    });

    return errorArray;
  }

  toQueryParamObject() {
    const params = {};

    if (this.hideAttribution !== undefined) params.hideAttribution = this.hideAttribution;
    if (this.hideModalButton !== undefined) params.hideModalButton = this.hideModalButton;
    if (this.modalButtonText) params.modalButtonText = this.modalButtonText;
    if (this.providerIdOrder) params.providerIdOrder = this.providerIdOrder;
    if (this.providerIdBlacklist) params.providerIdBlacklist = this.providerIdBlacklist;
    if (this.providerIdWhitelist) params.providerIdWhitelist = this.providerIdWhitelist;
    if (this.useDarkLogos) params.useDarkLogos = this.useDarkLogos;
    if (this.borderColor) params.borderColor = this.borderColor;
    if (this.borderHoverColor) params.borderHoverColor = this.borderHoverColor;
    if (this.textColor) params.textColor = this.textColor;
    if (this.size) params.size = this.size;

    return { ...super.toQueryParamObject(), ...params };
  }
}



// WEBPACK FOOTER //
// ./src/models/publisher-brick-config.js